import type * as ds from '@attain-apps/fe/web/main/lib/design'

import type * as me from '../../../../../me'
import type * as currentRendering from '../../feature'

import type { Feature } from './feature'

export class Selectors {
  /** TODO */
  private readonly _page

  /**
   * Title of the current page.
   *
   * Resolution logic:
   * - If a page query exists (`hasPageQuery` is true):
   *   → use the page's own title if defined, otherwise fall back to the rendering name.
   * - If there is no page query:
   *   → always use the rendering name.
   *
   * This ensures that the page query context takes precedence, but a valid
   * fallback is always available.
   */
  // TODO: Investigate clearing the previous page’s title when navigating,
  // and remove reliance on `hasPageQuery` in this calculation.
  public readonly title

  /** TODO */
  public readonly breadcrumbs

  /** TODO */
  public readonly isLoading

  /** TODO */
  public readonly error

  constructor(
    feature: Feature,
    meFeature: me.Feature,
    currentRenderingFeature: currentRendering.Feature,
  ) {
    this._page = feature.state.project(state => state.page)

    const infoName = this._page.project(info => info?.title)

    // NOTE: The hasPageQuery check is a temporary workaround for a bug.
    // When navigating from a page with a query (and title) to one without,
    // the old title is not cleared, causing it to appear on the new page.
    this.title = infoName.project(
      meFeature.contexts.selectors.appPage.asSelector,
      currentRenderingFeature.selectors.hasPageQuery.asSelector,
      (pageName, appPage, hasQuery) => {
        if (hasQuery) {
          return pageName ?? appPage?.name
        }
        return appPage?.name
      },
    )

    const rawBreadcrumbs = this._page.project(info => info?.breadcrumbs ?? [])
    this.breadcrumbs = rawBreadcrumbs.project(
      this.title.asSelector,
      (state: object) => state,
      (_rawBreadcrumbs, title, state) => {
        const uiBreadcrumbs: ds.layout.page.child.header.models.Breadcrumb[] =
          _rawBreadcrumbs.map(({ name, goto }) => ({
            name,
            url: meFeature.contexts.selectors
              .getUrlForLink({ goto })
              .asSelector(state),
          }))

        if (title) {
          uiBreadcrumbs.push({ name: title })
        }

        return uiBreadcrumbs
      },
    )

    this.isLoading = feature.state.project(state => state.isLoading)

    this.error = feature.state.project(state => state.error)
  }
}
